import I18n from '~/src/common/services/I18n';
import type { Order } from '~/src/common/typings/order';

export const getSingleOrderSpinnerText = (state: Order['state']) => {
  const states = [
    // Index pour state non trouvé = 1 (-1 + 2)
    ['preparing', 'prepared', 'approvedByClient'], // Index = 2 (0 + 2)
    ['cart', 'ready', 'inTransit', 'readyToDeliver'], // Index = 3 (1 + 2)
  ];
  const index = 2 + states.findIndex(s => s.includes(state));
  const count = 1 + states.length;
  return `${index}/${count}`;
};

export const getSingleOrderTitle = (state: Order['state']) => {
  switch (state) {
    case 'preparing':
    case 'prepared':
    case 'approvedByClient':
      return I18n.t('home.order.preparing');

    case 'ready':
      return I18n.t('home.order.pickup-ready');

    case 'cart':
    case 'inTransit':
    case 'readyToDeliver':
      return I18n.t('home.order.delivering');

    default:
      return I18n.t('home.order.accepted');
  }
};
